const SSR_ONLY_BOT = 'SSR';
const DEFAULT_BOT = 'DEFAULT';

export const BOT_TYPE = 'bt';

type BotType = typeof SSR_ONLY_BOT | typeof DEFAULT_BOT;

export const isBotType = (botType: unknown): botType is BotType => {
    return botType === SSR_ONLY_BOT || botType === DEFAULT_BOT;
};

export const isSsrOnlyBot = (botType: BotType | undefined): boolean => {
    return botType === SSR_ONLY_BOT;
};

export const isBot = (botType: BotType | undefined): boolean => {
    return !!botType;
};
